import {Injectable} from '@angular/core';
import {EvaluationSubCriteriaImportanceScore} from '@frontend/shared-api';
import {TabStatusEnum} from '../tabs/tab-status.model';

export interface ProgressCalculationItem {
  id?: number;
  selectedImportanceScore?: EvaluationSubCriteriaImportanceScore;
}

export interface TabWithAttributes {
  id: number;
  attributes: ProgressCalculationItem[];
}

@Injectable({
  providedIn: 'root',
})
export class ImportanceScoreProgressService {
  calculateAttributeCompletionStatus(attributes: ProgressCalculationItem[]): TabStatusEnum {
    const totalAttributes = attributes.length;
    const completedAttributes = attributes.filter(
      (attr) => attr.selectedImportanceScore !== undefined && attr.selectedImportanceScore !== null,
    ).length;

    if (totalAttributes === 0) {
      return TabStatusEnum.NOT_STARTED;
    } else if (completedAttributes === totalAttributes) {
      return TabStatusEnum.COMPLETED;
    } else if (completedAttributes > 0) {
      return TabStatusEnum.IN_PROGRESS;
    } else {
      return TabStatusEnum.NOT_STARTED;
    }
  }

  updateTabClasses<T extends TabWithAttributes>(tabs: T[]): Record<number, string> {
    const updatedClasses: Record<number, string> = {};

    tabs.forEach((tab) => {
      updatedClasses[tab.id] = this.calculateAttributeCompletionStatus(tab.attributes);
    });

    return updatedClasses;
  }

  calculatePartialProgress(attributes: ProgressCalculationItem[]): boolean {
    const totalAttributes = attributes.length;
    const completedAttributes = attributes.filter(
      (attr) => attr.selectedImportanceScore !== undefined && attr.selectedImportanceScore !== null,
    ).length;

    return completedAttributes > 0 && completedAttributes < totalAttributes;
  }
}
